<form>
  <div class="row">
    <div class="col-md-12 col-xl-12">
      <div class="table-responsive our-table">
        <table class="table table-striped text-nowrap mb-0 title-case-table">
          <thead class="border-top">
            <tr>
              <th>Data</th>
              <th>ID Operador</th>
              <th>Nome Projeto</th>
              <th>Processamento</th>
              <th>Qt. Aposta</th>
              <th>Total Aposta</th>
              <th>Qt. Perdas</th>
              <th>Total Perdas</th>
              <th>Qt. Prêmios</th>
              <th>Total Prêmios</th>
              <th>RTP</th>
              <th>GGR Gerado</th>
              <th>Alíquota GGR</th>
              <th>GGR Devido</th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-bottom" *ngFor="let row of rows">
              <td>{{ row?.date | date : "dd/MM/yyyy" : "GMT" }}</td>
              <td>{{ row?.accountId || "-" }}</td>
              <td>{{ row?.nomeProjeto || "-" }}</td>
              <td>{{ row?.createdAt | date : "dd/MM/yyyy HH:mm:ss" : "GMT" }}</td>
              <td>{{ row?.countBet ?? 0 }}</td>
              <td>{{ row?.totalBet ?? 0 | formatCurrency }}</td>
              <td>{{ row?.countLoss ?? 0 }}</td>
              <td>{{ row?.totalLoss ?? 0 | formatCurrency }}</td>
              <td>{{ row?.countsAwards ?? row?.countAwards ?? 0 }}</td>
              <td>{{ row?.totalAwards ?? 0 | formatCurrency }}</td>
              <td>{{ row?.rtp ?? 0 | number : "1.2-2" }}%</td>
              <td>{{ row?.balanceGGR ?? 0 | formatCurrency }}</td>
              <td>{{ row?.percentGGR ?? 0 | number : "1.2-2" }}%</td>
              <td>{{ row?.debtorGGR ?? 0 | formatCurrency }}</td>
            </tr>
            <tr *ngIf="rows.length == 0">
              <td colspan="14">{{ "common.noData" | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between p-2">
        <ngb-pagination
          [collectionSize]="total"
          [maxSize]="5"
          [rotate]="true"
          [(page)]="page"
          [pageSize]="pageSize"
          (pageChange)="pageChange()"
        >
        </ngb-pagination>
      </div>
    </div>
  </div>
</form>